import { MonoAvatarModule } from '../../../shared/directives/mono-avatar/mono-avatar.module';
import { ModalsModule } from '../../../widgets/entry-components/modal/modals.module';
import { SinControllerModule } from '../../patient/sin-controller/sin-controller.module';
import { OrganizationAddComponent } from './organization-add.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { PatientPipesModule } from '../../patient/pipes/patient-pipes.module';

@NgModule({
  declarations: [OrganizationAddComponent],
  imports: [
    PatientPipesModule,
    CommonModule, IonicModule, FormsModule, ReactiveFormsModule, SinControllerModule, ModalsModule, TranslateModule,
    MonoAvatarModule
  ],
  exports: [OrganizationAddComponent]
})
export class OrganizationAddModule { }
